import { AfterViewInit, Component, HostListener, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { UserManagementService } from 'src/app/components/admin/user-management/pages/user-management/user-management.service';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit ,AfterViewInit{
  passwordsMatch: boolean = true;
  @Output() inputValueEmit:EventEmitter<string> = new EventEmitter();
  @Input () inputLabel :string = 'password';
  @Input () inputType:string;
  @Input () inputValue : string = "";
  @Input () inputDefaultShow:boolean=false
  @Input () inputReqValidation:boolean = false;
  showHide:boolean=true
  @Input() shouldPhoneFormat:boolean=false;
  @Input() shouldBogieFormat:boolean=false;  
  @Input() inputMaxlength:boolean=false;
  @Input() inputReadonly : boolean  = false;
  @Input() passwordFormat:boolean = false;
  @Input() isInputDisabled = false;
  @Input() isValid: boolean =false;
  @Input() isSvgVisible : boolean = false;
  @Input() labelStyle: { [key: string]: string } = {};
  @Input() tabInput : boolean = false;
  @Input() disabled: boolean = false;
  @Output() inputblurValueEmit = new EventEmitter<string>();
  @Output() emailValidityChange = new EventEmitter<boolean>();
  
  // Email validation
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
  isEmailInvalid: boolean = false;

  inputPattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}$"
  // extensionPattern = "(^[0-9$@$!%*?&]+$"
  constructor(
    public userManagementService: UserManagementService,

  ) { }

  ngOnInit(): void {
    this.inputValue = this.inputValue??''
  }

  ngAfterViewInit(): void {
    document.getElementById('hidden').focus()
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ' && this.inputLabel.includes('Password')) {
      event.preventDefault();
    }
  }
  passwordPattern(){
    if(this.inputLabel.includes('Password')){
      return this.inputPattern;
    }
  }

  clearInput(){
    if(!this.inputReadonly){
      this.inputValue = ''
      if (this.inputType === 'email') {
        this.isEmailInvalid = false;
        this.emailValidityChange.emit(false);
      }
    }
  }
  onBlur(){
  this.inputblurValueEmit.emit(this.inputValue)
}

  onInputChange(): void {
    this.inputValueEmit.emit(this.inputValue);
    if (this.inputType === 'email') {
      this.validateEmail();
    }
  }

  validateEmail(): void {
    this.isEmailInvalid = false;
    const email = this.inputValue;
    if (email !== '' && email !== undefined && email !== null) {
      this.isEmailInvalid = !this.emailPattern.test(email);
    }
    this.emailValidityChange.emit(this.isEmailInvalid);
  }

}